import React from 'react';
import PropTypes from 'prop-types';
import { LEVELS } from './const';

export default function Language({ language }) {
    const {
        name,
        native_name,
        level
    } = language;

    return (
        <li>
            {name}
            &nbsp;{name !== native_name && <strong>({native_name})</strong>}
            &nbsp;- <span>{LEVELS[level]}</span>
        </li>
    );
}

Language.propTypes = {
    language: PropTypes.shape({
        name: PropTypes.string,
        native_name: PropTypes.string,
        level: PropTypes.number
    })
};

Language.defaultProps = {
    language: {
        name: '',
        native_name: '',
        level: 0
    }
};



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/Languages/Language.js